import React from 'react';
import { FieldDisplayProps } from '../../types';

export const BooleanFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  onValueChange,
  isReadOnly,
}) => {
  const isChecked = value === 'true' || value === '1' || value === 'yes';

  const handleToggle = () => {
    if (!isReadOnly) {
      onValueChange(isChecked ? 'false' : 'true');
    }
  };

  return (
    <div
      className="boolean-cell editable"
      onClick={handleToggle}
      onDoubleClick={onStartEditing}
    >
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
        onClick={(e) => e.stopPropagation()}
        disabled={isReadOnly}
        className="boolean-checkbox"
      />
    </div>
  );
};

export default BooleanFieldDisplay;
